import { render, staticRenderFns } from "./PigmentationTemplate.vue?vue&type=template&id=508c29a4"
import script from "./PigmentationTemplate.vue?vue&type=script&lang=js"
export * from "./PigmentationTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports